const loading = false;

export default loading;